<template>
  <main>
    <div class="page" v-if="post">
      <header class="page-header">
        <p>{{ post.categories.nodes[0].name }}</p>
      </header>
      <div class="page-content">
        <article class="post">
          <div class="post-header">
            <p class="post-date">{{ getFormatDate(post.date) }}</p>
            <h1 class="post-title">{{ post.title }}</h1>
          </div>
          <div class="post-content template" v-html="post.content"></div>
        </article>
      </div>
    </div>

    <div class="page" v-else>
        <div class="page-content">
          <p class="empty">データが取得できないためプレビューできません</p>
        </div>
      </div>
  </main>
</template>

<script>
// import { Component, Vue } from 'vue-property-decorator';
// import getUsersGql from '~/apollo/queries/getUsers.gql';
// import gql from 'graphql-tag'
// import getPostsGql from '../apollo/queries/getPosts.gql'
// import getNewsPostsGql from '../apollo/queries/getNewsPosts.gql'
import getDraftPostByPostIdGql from '../apollo/queries/getDraftPostByPostId.gql'

export default {
  name: 'Preview',
  data () {
    return {
      post: null,
    }
  },
  methods: {

  },
  apollo: {
    post: {
      query: getDraftPostByPostIdGql,
      // update: (data) => {
      //   return data.posts.edges.length ? data.posts.edges[0].node : null
      // },
      variables () {
        return {
          postId: parseInt(this.$route.query.p),
        }
      },
      error(error) {
        this.error = JSON.stringify(error.message)
      }
    },
  }
}
</script>

<style lang="stylus" scoped>

</style>
